import L from 'leaflet';

type LatLng = {
  lng: number;
  lat: number;
};

export const cleanUpMap = (map: L.Map) => {
  map.eachLayer(function (layer: any) {
    if (layer.pm && typeof layer.remove === 'function') {
      layer.remove();
    }
  });
};

export const calculateMidpoint = (latlngs: LatLng[]): L.LatLng => {
  let latSum = 0;
  let lngSum = 0;

  latlngs.forEach((latlng) => {
    latSum += latlng.lat;
    lngSum += latlng.lng;
  });

  const midLat = latSum / latlngs.length;
  const midLng = lngSum / latlngs.length;

  return L.latLng(midLat, midLng); // Return as a Leaflet LatLng object
};